<template>
  <ActionSheet
    class="sharing-sheet"
    :close-click-outside="closeClickOutside"
    v-on="$listeners"
  >
    <p class="sharing-sheet__headline">Поделиться</p>
    <SharingList :article="article" />
  </ActionSheet>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ActionSheet from '~/components/ActionSheet.vue';
  import type { IFullArticle, TArticle } from '~/types/common';
  import SharingList from '~/components/Sharing/SharingList.vue';
  export default defineNuxtComponent({
    name: 'SharingMobile',
    components: {
      ActionSheet,
      SharingList,
    },

    props: {
      closeClickOutside: {
        type: Boolean as PropType<boolean>,
        default: false,
      },

      article: {
        type: Object as PropType<TArticle | IFullArticle>,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .sharing-sheet {
    &__headline {
      font-family: $text-font--1;
      @include normalText;
      font-weight: 500;
      padding-left: $spacing-6;
    }
  }
</style>
